import { render, staticRenderFns } from "./ReportJourney.vue?vue&type=template&id=54886560&scoped=true&"
import script from "./ReportJourney.vue?vue&type=script&lang=js&"
export * from "./ReportJourney.vue?vue&type=script&lang=js&"
import style0 from "./ReportJourney.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReportJourney.vue?vue&type=style&index=1&id=54886560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54886560",
  null
  
)

export default component.exports